export function getStatusDataSource() {
    return [
        {
            label: '成功',
            value: 'success',
        },
        {
            label: '警告',
            value: 'warning',
        },
        {
            label: '错误',
            value: 'error',
        },
        {
            label: '提示',
            value: 'info',
        },
        {
            label: '无效',
            value: 'invalid',
        },
    ];
}
export function getTypeDataSource() {
    return [
        {
            title: '正常（normal）',
            value: 'normal',
        },
        {
            title: '主要（primary）',
            value: 'primary',
        },
        {
            title: '次要（secondary）',
            value: 'secondary',
        },
    ];
}
